import React from "react"
import classNames from "classnames"

import "./Button.sass"

const Button = ({
  children,
  className,
  isDanger = false,
  isInverse = false,
  onClick,
  href,
  ...rest
}) => {
  const buttonClassName = classNames({
    Button: true,
    isInverse: isInverse,
    isDanger: isDanger,
    [className]: !!className,
  })

  function handleClick(e) {
    // eslint-disable-next-line no-restricted-globals
    if (isDanger && !confirm("Ali ste prepričani?")) {
      e.preventDefault()
      return false
    }

    onClick && onClick(e)
  }

  const ButtonTag = href ? 'a' : 'button';

  return (
    <ButtonTag className={buttonClassName} onClick={handleClick} href={href} {...rest}>
      {children}
    </ButtonTag>
  )
}

export default Button
